<template>
    <label class="inline-flex items-center text-gray-600 dark:text-gray-400">
        <input type="checkbox" :value="value" v-model="proxyChecked"
               class="text-gray-600 form-checkbox focus:border-red-400 focus:outline-none focus:shadow-outline-red dark:focus:shadow-outline-gray">
        <span class="ml-2"><slot></slot></span>
    </label>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    emits: ['update:checked'],

    props: {
        checked: {
            type: [Array, Boolean],
            default: false,
        },
        value: {
            default: null,
        },
    },

    computed: {
        proxyChecked: {
            get() {
                return this.checked;
            },

            set(val) {
                this.$emit("update:checked", val);
            },
        },
    },
})
</script>
